<script setup lang="ts">
defineProps({ blok: Object });
</script>

<template>
  <section class="py-20">
    <UiContainer max-width="max-w-3xl">
      <header class="insight-category-header">
        <img :src="blok?.icon.filename" :alt="blok?.icon.alt" />
        <StoryblokRichText :doc="blok?.header" />
      </header>
    </UiContainer>
    <UiContainer>
      <div
        class="grid grid-cols-2 gap-x-20 items-center max-[769px]:grid-cols-1 max-[769px]:gap-x-0 max-[769px]:gap-y-10"
      >
        <div class="flex flex-col items-center justify-center">
          <img
            v-motion-slide-visible-once-bottom
            :src="blok?.image.filename"
            :alt="blok?.image.alt"
            class="max-[769px]:hidden"
          />
          <div class="insighr-category-description">
            <StoryblokRichText :doc="blok?.claim" />
          </div>
        </div>
        <div class="insighr-category-description">
          <StoryblokRichText :doc="blok?.description" />
        </div>
      </div>
    </UiContainer>
  </section>
</template>
